import FlexPaneViewState from './schema/FlexPaneViewState';
import { createStore } from 'satcheljs';

export default createStore<FlexPaneViewState>('flexPaneViewState', {
    isShown: false,
})();
